import { Container } from '@twistopayments/design-system/components/atoms/container'

import type { SectionsHtmlEmbedComponent } from '@twisto/api-cms'

import { DynamicContent } from 'homepage/components/atoms'

import * as styles from './html-embed.styles'

export const HTMLEmbed = ({ input }: SectionsHtmlEmbedComponent) => {
  if (!input) {
    return null
  }

  return (
    <Container as="section" css={styles.section} size="wider">
      <DynamicContent content={input} />
    </Container>
  )
}
